$(function () {
    setTimeout(() => {
        $('.loading-screen').fadeOut(500);
    }, 500);
});